
import { useApp } from '@/hooks/useApp'
import { useEffect } from 'react'
import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Step2Form } from '../../../containers/chaloupka/Step2Form'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'
import { StepsContent } from '../../../context/StepsContext'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'

export const Step2 = () => {
  const { product, setProduct } = useApp()
  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData } = useInsuranceParamsContext()

  useEffect(() => {
    if (insuranceParams?.generalParams?.insuranceCategoryType)
      setProduct(insuranceParams?.generalParams?.insuranceCategoryType)
  }, [insuranceParams?.generalParams?.insuranceCategoryType])

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {!isLoadingData && paramsId && insuranceParams && product == insuranceParams.generalParams.insuranceCategoryType && 
          <StepsContent sx={{ minH: '3000px' }} step={2}>
            <Steps icon="house" />

            <InsuranceInfo />

            <Step2Form />
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}
